import { getTokenHeader, isTokenValid } from "./JWT";
import store from "../configureStore";
import { getNewAccessToken, setAccessToken } from "../Containers/App/action";
import { logout } from "../Pages/Login/action";
import { toast } from "react-toastify";

export const requestInterceptor = (req) => {
    if (store.getState().app.isAuthenticated){
        const accessToken = store.getState().app.accessToken;
        req.headers = getTokenHeader(accessToken);
    }
    req.headers.origin = process.env.REACT_APP_ORIGIN;
    return req;
}
export const responseInterceptor = (res) => {
    const { dispatch } = store;
    res = res.data;
    if (res.accessToken){
        const { accessToken } = res;
        dispatch(setAccessToken(accessToken));
    }
    return res;
}
export const errorInterceptor = async(error) => {
    try {
        const { dispatch } = store;
        const state = store.getState();
        const { accessToken, refreshToken } = state.app;
        const action = error.response.data?.action;
        if(accessToken && refreshToken && !action){
            if(!isTokenValid(accessToken) && isTokenValid(refreshToken)){
                dispatch(getNewAccessToken(refreshToken));
            }
        }else if(action){
            dispatch(logout(()=>{
                toast.error("We're sorry! It looks like you need to sign in again.. :(");
                setTimeout(function() {
                    window.location.href ='/login'
                }, 2000);}))
        }
        return error;
    } catch (error) {
        return;
    }
}